import ChargePoints from './ChargePoints';

export default ChargePoints;